import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { MasterDataListFacade } from './master-data-list.facade';

@Injectable({
  providedIn: 'root',
})
export class MasterDataListGuard {
  constructor(private masterDataListFacade: MasterDataListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.masterDataListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.masterDataListFacade);
  }
}
